import { Box, Typography, useTheme} from '@mui/material'
import React from 'react'
import { tokens } from "../theme";

const Dracena = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: '32px 16px', md: '64px 32px' },
        backgroundImage: 'url(/assets/fondoNavidad.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.35) 60%, rgba(0, 0, 0, 0.6) 100%)',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          textAlign: 'center',
          color: colors.grey[100],
          maxWidth: '720px',
          width: '100%',
        }}
      >
        {/* <Typography
          variant="body2"
          sx={{
            letterSpacing: 3,
            textTransform: 'uppercase',
            fontWeight: 600,
            color: '#f8d27a',
          }}
        >
          Temporada Navideña 2025
        </Typography> */}
        <Box
          sx={{
            width: { xs: '58%', sm: '220px', md: '260px' },
          }}
        >
          {/* <img
            src="/assets/dracena2.png"
            alt="logo"
            style={{ width: '100%', height: 'auto' }}
          /> */}
        </Box>
        {/* <Typography
          variant="h2"
          sx={{
            marginBottom: '8px',
            fontSize: { xs: '2.1rem', sm: '2.8rem', md: '3.2rem' },
            fontWeight: 600,
            lineHeight: 1.2,
          }}
        >
          Bienvenidos al Sistema
        </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: '480px',
            fontSize: { xs: '1rem', md: '1.08rem' },
            opacity: 0.9,
          }}
        >
          Gestiona procesos, consulta reportes y celebra con nosotros esta temporada especial manteniendo las operaciones siempre bajo control.
        </Typography> */}
        {/* <Box
          sx={{
            display: 'flex',
            gap: '14px',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          {['Interfoliados', 'Reportes', 'Producción'].map((label) => (
            <Box
              key={label}
              sx={{
                minWidth: '118px',
                padding: '10px 20px',
                borderRadius: '999px',
                backgroundColor: 'rgba(255, 255, 255, 0.18)',
                boxShadow: '0 12px 28px rgba(0, 0, 0, 0.25)',
                fontWeight: 600,
                backdropFilter: 'blur(6px)',
              }}
            >
              {label}
            </Box>
          ))}
        </Box> */}
      </Box>
    </Box>
  )
}
export default Dracena
